var statusWindow = document.getElementById('window_validation_status');

(function (win)
{
    //Private variables
    var _LOCALSTORAGE_KEY = 'WINDOW_VALIDATION';
    var RECHECK_WINDOW_DELAY_MS = 100;
    var _initialized = false;
    var _isMainWindow = false;
    var _unloaded = false;
    var _windowArray;
    var _windowId;
    var _isNewWindowPromotedToMain = false;
    var _onWindowUpdated;    
    function WindowStateManager(isNewWindowPromotedToMain, onWindowUpdated)
    {     
        _onWindowUpdated = onWindowUpdated;
        _isNewWindowPromotedToMain = isNewWindowPromotedToMain;
        _windowId = Date.now().toString();
        bindUnload();
        determineWindowState.call(this);
        _initialized = true;
        _onWindowUpdated.call(this);
    }
    //Determine the state of the window 
    //If its a main or child window
    function determineWindowState()
    {
        var self = this;
        var _previousState = _isMainWindow;
        _windowArray = localStorage.getItem(_LOCALSTORAGE_KEY);
        if (_windowArray === null || _windowArray === "NaN")
        {
            _windowArray = [];
        }
        else
        {
            _windowArray = JSON.parse(_windowArray);
        }                  
        if (_initialized)
        {
            //Determine if this window should be promoted
            if (_windowArray.length <= 1 ||
               (_isNewWindowPromotedToMain ? _windowArray[_windowArray.length - 1] : _windowArray[0]) === _windowId)
            {
                _isMainWindow = true;
            }
            else
            {
                _isMainWindow = false;
            }
        }
        else
        {
            if (_windowArray.length === 0)
            {
                _isMainWindow = true;
                _windowArray[0] = _windowId;               
                localStorage.setItem(_LOCALSTORAGE_KEY, JSON.stringify(_windowArray));
            }
            else
            {
                console.log("child->"+_windowId);

                _isMainWindow = false;
                _windowArray.push(_windowId);
                localStorage.setItem(_LOCALSTORAGE_KEY, JSON.stringify(_windowArray));
            }
        }
              if (_previousState !== _isMainWindow)
        {
            _onWindowUpdated.call(this);
        }
        if (window.location.href.indexOf("/apps/") > -1) {
            _initialized =  false;
            _isMainWindow = true;    
            console.log("Contains apps In URL -->"+_isMainWindow);                     
        }               
    }
    //Remove the window from the global count
    function removeWindow()
    {
        var __windowArray = JSON.parse(localStorage.getItem(_LOCALSTORAGE_KEY));
        for (var i = 0, length = __windowArray.length; i < length; i++)
        {
            if (__windowArray[i] === _windowId)
            {
                __windowArray.splice(i, 1);
                break;
            }
        }
        //Update the local storage with the new array
        localStorage.setItem(_LOCALSTORAGE_KEY, JSON.stringify(__windowArray));
    }
    function bindUnload()
    {
        win.addEventListener('beforeunload', function ()
        {
            if (!_unloaded)
            {
                removeWindow();
            }
        });
        win.addEventListener('unload', function ()
        {
            if (!_unloaded)
            {
                removeWindow();
            }
        });
    }
    WindowStateManager.prototype.isMainWindow = function ()
    {    
        return _isMainWindow;
    };
    WindowStateManager.prototype.resetWindows = function ()
    {
        localStorage.removeItem(_LOCALSTORAGE_KEY);
    };
    win.WindowStateManager = WindowStateManager;
})(window);
var WindowStateManager = new WindowStateManager(false, windowUpdated);
function getAppName() {
    let appName = 'CitusHealth Desktop App';
    // Get app name from page title (set by tenant-white-labeling.js)
    const pageTitle = document.title;
    if (pageTitle && pageTitle.trim() !== '') {
        appName = pageTitle;
    }
    return appName;
}

function windowUpdated(){
    if(statusWindow) {
        statusWindow.className = (this.isMainWindow() ? 'main' : 'child');
        if(statusWindow.className == "child" && (performance.navigation.type != performance.navigation.TYPE_RELOAD && window.location.href.indexOf('gcAuthStatus') === -1) ){
            const appName = getAppName();
            alert('We have noticed you are opening ' + appName + ' in another tab and ' + appName + ' cannot be used in more than one tab. Only use it in one Browser tab or Browser instance for a given Browser');
            document.addEventListener("multiTabActivityFired", function (e) {
                var activityData = {
                    activityName: "Multi tab detection",
                    activityType: "MultiTabDetection",
                    activityDescription: "Activity Track Page :- Application detected in another tab. So warning message displayed."
                };
                e.detail._structureService.trackActivity(activityData);
            });
        }
    }
}


// WEBPACK FOOTER //
// src/assets/window_validation.js